import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { StartDemoForm } from "./StartDemoForm";
import { NotFound } from "../NotFound";
import { useBrand } from "../../data/brand";
import { GameHeader } from "../components/GameHeader";
import { GameScreen, ScreenAreaRenderProps } from "../components/GameScreen";
import { Markdown } from "../components/Markdown";

const Container = styled.div`
  overflow-y: auto;
`;

const MarketingContainer = styled.div`
  padding: 0 16px;
  display: flex;
  flex-direction: column;
`;
const TopMarketingContainer = styled(MarketingContainer)`
  padding-top: 32px;
`;
const BottomMarketingContainer = styled(MarketingContainer)``;
const StartDemoFormContainer = styled.div`
  padding: 32px 16px;
`;

export const DemoStart = () => {
  const { t } = useTranslation();
  const {
    brandDetails: { allowDemoGames, landingPageContent },
  } = useBrand();

  const renderHeader = React.useCallback(
    ({ toggleMenu }: ScreenAreaRenderProps) => {
      return (
        <GameHeader toggleMenu={toggleMenu} title={t("demoStart.title")} />
      );
    },
    [t]
  );

  const renderBody = React.useCallback(() => {
    return (
      <Container>
        {!!landingPageContent?.demoGame?.top && (
          <TopMarketingContainer>
            <Markdown source={landingPageContent.demoGame.top} />
          </TopMarketingContainer>
        )}

        <StartDemoFormContainer>
          <StartDemoForm />
        </StartDemoFormContainer>

        {!!landingPageContent?.demoGame?.bottom && (
          <BottomMarketingContainer>
            <Markdown source={landingPageContent.demoGame.bottom} />
          </BottomMarketingContainer>
        )}
      </Container>
    );
  }, [landingPageContent]);

  // Show a 404 if demos are not enabled
  if (!allowDemoGames) {
    return <NotFound />;
  }

  // Render the screen
  return <GameScreen renderHeader={renderHeader} renderBody={renderBody} />;
};
